module.exports = __webpack_public_path__ + "img/slide6.189d13c0.png";